import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.b('icon')),
      "aria-hidden": "true"
    }, [
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        _createTextVNode("i")
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('content'))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}